const geojsonData = {
    type: "FeatureCollection",
    "features": [
    {
      "type": "Feature",
      "id": "smaa640ec7",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.617753216, -1.342839031],
            [36.618874379, -1.343908937],
            [36.620411283, -1.341893811],
            [36.619692451, -1.341142999],
            [36.619075543, -1.341196628],
            [36.617753216, -1.342839031]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN16",
      },
    },
    {
      "type": "Feature",
      "id": "smd4780986",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.618874379, -1.343908937],
            [36.617753216, -1.342839031],
            [36.616409429, -1.344531039],
            [36.617549368, -1.345633123],
            [36.618874379, -1.343908937]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN15",
      },
    },
    {
      "type": "Feature",
      "id": "sm17e9e98b",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.617549368, -1.345633123],
            [36.616409429, -1.344531039],
            [36.615230279, -1.346012872],
            [36.616387971, -1.34716156],
            [36.617549368, -1.345633123]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN14",
      },
    },
    {
      "type": "Feature",
      "id": "smc393a87a",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.616387971, -1.34716156],
            [36.615230279, -1.346012872],
            [36.614153697, -1.347361306],
            [36.615328497, -1.348545197],
            [36.616387971, -1.34716156]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN13",
      },
    },
    {
      "type": "Feature",
      "id": "smf20af966",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.615328497, -1.348545197],
            [36.614153697, -1.347361306],
            [36.61315591, -1.348633684],
            [36.614385704, -1.349801462],
            [36.615328497, -1.348545197]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN12",
      },
    },
    {
      "type": "Feature",
      "id": "smd843b87e",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.614385704, -1.349801462],
            [36.61315591, -1.348633684],
            [36.612270784, -1.349719676],
            [36.613485824, -1.350969238],
            [36.614385704, -1.349801462]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN11",
      },
    },
    {
      "type": "Feature",
      "id": "smc7c8728f",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.613485824, -1.350969238],
            [36.612270784, -1.349719676],
            [36.611430609, -1.350740787],
            [36.612665068, -1.352060592],
            [36.613485824, -1.350969238]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN10",
      },
    },
    {
      "type": "Feature",
      "id": "sm07a0a812",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.612665068, -1.352060592],
            [36.611430609, -1.350740787],
            [36.61142052, -1.350753382],
            [36.611192535, -1.350545566],
            [36.610586356, -1.351327212],
            [36.610736554, -1.351624861],
            [36.61201865, -1.352903917],
            [36.612665068, -1.352060592]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN09",
      },
    },
    {
      "type": "Feature",
      "id": "sm7a158768",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.610586356, -1.351327212],
            [36.611192535, -1.350545566],
            [36.610953816, -1.350289489],
            [36.611205402, -1.349967183],
            [36.60988409, -1.34865152],
            [36.609424956, -1.349200818],
            [36.610586356, -1.351327212]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN08",
      },
    },
    {
      "type": "Feature",
      "id": "smc13fd623",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.60988409, -1.34865152],
            [36.611205402, -1.349967183],
            [36.611972059, -1.348985023],
            [36.610689874, -1.347687496],
            [36.60988409, -1.34865152]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN07",
      },
    },
    {
      "type": "Feature",
      "id": "sm51fe268c",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.610689874, -1.347687496],
            [36.611972059, -1.348985023],
            [36.6128218, -1.347896423],
            [36.611545886, -1.34666338],
            [36.610689874, -1.347687496]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN06",
      },
    },
    {
      "type": "Feature",
      "id": "sm0f7beff7",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.611545886, -1.34666338],
            [36.6128218, -1.347896423],
            [36.61374118, -1.346718609],
            [36.612498426, -1.34552378],
            [36.611545886, -1.34666338]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN05",
      },
    },
    {
      "type": "Feature",
      "id": "sm9060edf9",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.612498426, -1.34552378],
            [36.61374118, -1.346718609],
            [36.614758208, -1.345415698],
            [36.61356422, -1.344248684],
            [36.612498426, -1.34552378]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN04",
      },
    },
    {
      "type": "Feature",
      "id": "sm638f59d6",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.61356422, -1.344248684],
            [36.614758208, -1.345415698],
            [36.615889257, -1.343966715],
            [36.614753449, -1.342825912],
            [36.61356422, -1.344248684]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN03",
      },
    },
    {
      "type": "Feature",
      "id": "sm8d7c6495",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.614753449, -1.342825912],
            [36.615889257, -1.343966715],
            [36.617200046, -1.342287466],
            [36.616102686, -1.341211709],
            [36.614753449, -1.342825912]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN02",
      },
    },
    {
      "type": "Feature",
      "id": "sm688c5d8f",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [36.616102686, -1.341211709],
            [36.617200046, -1.342287466],
            [36.618501551, -1.34062011],
            [36.618480094, -1.339947059],
            [36.618480094, -1.339947059],
            [36.617742486, -1.33924988],
            [36.616102686, -1.341211709]
          ]
        ]
      },
      properties: {
        Unit_Number: "GN01",
      },
    }
  
    ],
    
};

export default geojsonData;
